import { Component, inject } from "@angular/core";
import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";

import { map } from "rxjs/operators";
import { CommonModule } from "@angular/common";

@Component({
  selector: "onsip-signup-common-layout",
  templateUrl: "./signup-common-layout.component.html",
  styleUrls: ["./signup-common-layout.component.scss"],
  imports: [CommonModule]
})
export class SignUpCommonLayoutComponent {
  private breakpoint = inject(BreakpointObserver);

  showRightContent = this.breakpoint
    .observe([Breakpoints.XLarge, Breakpoints.Large, Breakpoints.Medium])
    .pipe(map(state => state.matches));
}
